import React from "react";
import { useLocation } from "react-router-dom";
import { BreadcrumbsNav, 
  BreadcrumbsContainer, 
  BreadcrumbsItem, 
  BreadcrumbsSeparator 
} from "./Breadcrumbs.styles";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  function kebabToTitleCase(str) {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return (
    <BreadcrumbsNav data-testid="breadcrumbs">
      <BreadcrumbsContainer>
        {pathSegments.map((segment, index) => (
          <React.Fragment key={index}>
            {index > 0 && <BreadcrumbsSeparator>{">"}</BreadcrumbsSeparator>}
            <BreadcrumbsItem>{kebabToTitleCase(segment)}</BreadcrumbsItem>
          </React.Fragment>
        ))}
      </BreadcrumbsContainer>
    </BreadcrumbsNav>
  );
};

export default Breadcrumbs;